// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCreateProjectRequest,
  TCreateProjectModel,
  IMappers,
  TCreateProjectResponse,
  TCreateProjectResponse_1,
  TCreateProjectResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TCreateProjectModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/create-project/',
  requestType: 'json',
  interserviceAuthEnabled: true,
} as TCreateProjectModel;

export function createCreateProjectModel(parameters: TCreateProjectRequest): TCreateProjectModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateProjectRequest;
}

export async function fetchCreateProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateProjectOptions<TResponse200, TResponse400>): Promise<TCreateProjectResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateProjectModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCreateProjectResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TCreateProjectResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateProjectResponse;
}
